<div
  class="teaser-container-wrapper"
  *ngIf="!isLoading; else loadingTeaserContainer"
>
  <!-- Title and Link -->
  <div
    class="teaser-container-link"
    [ngClass]="{ 'teaser-container-link--no-headline': !linkHeadline }"
    *ngIf="(linkHeadline || link) && !isLoading"
  >
    <h4 *ngIf="linkHeadline">{{ linkHeadline }}</h4>
    <hdi-link
      *ngIf="link"
      [label]="link.label | capitalize"
      [type]="LinkType.PRIMARY_ARROW"
      [href]="link.href ?? ''"
      [title]="link.title ?? ''"
      [hrefType]="link.hrefType ?? HrefType.ANGULAR_ROUTE"
    ></hdi-link>
  </div>
  <!-- End Title and Link -->
  <!-- Slider Teasers Template-->
  <ng-container
    *ngIf="
      caasData?.formData?.st_standard_layout?.value?.identifier === 'slider'
    "
  >
    <hdi-slider
      [sliderType]="SliderType.TEASER"
      [caasData]="getMappedCaasData()"
    ></hdi-slider>
  </ng-container>
  <!-- End Slider Teasers Template-->
  <!-- List Teaser Template-->
  <div
    *ngIf="
      caasData?.formData?.st_standard_layout?.value?.identifier !== 'slider'
    "
    #teaserList
    class="teaser-container"
    [ngClass]="{
      'teaser-container--3-col': columns === 0 || columns === 3,
      'teaser-container--2-col': columns === 2,
      'teaser-container--no-overflow': !showMoreLess,
      'teaser-container--mini':
        caasData?.formData?.st_layout?.value?.identifier === 'mini',
      'teaser-container--mini--2-col':
        columns === 2 &&
        caasData?.formData?.st_layout?.value?.identifier === 'mini',
    }"
  >
    <ng-content></ng-content>
    <!-- Mini Teaser -->
    <ng-container
      *ngIf="caasData?.formData?.st_layout?.value?.identifier === 'mini'"
    >
      <ng-container
        *ngFor="
          let teaserMini of caasData?.formData?.st_items_mini?.value;
          let i = index
        "
      >
        <!-- Render <a> tag only if href is not '/404' -->
        <a
          *ngIf="getMiniTeaserHref(teaserMini) !== '/404'"
          [href]="getMiniTeaserHref(teaserMini)"
          [target]="getMiniTeaserTarget(teaserMini)"
          class="mini-teaser__link"
        >
          <hdi-teaser
            [caasData]="teaserMini"
            [isMini]="true"
            [miniBadges]="getMiniTeaserBadge(teaserMini)"
            [ngClass]="
              isGreen && !isSectionGrey ? 'mini-teaser-green' : 'mini-teaser'
            "
          >
          </hdi-teaser>
        </a>
        <!-- Render <hdi-teaser> directly if href is '/404' -->
        <hdi-teaser
          *ngIf="getMiniTeaserHref(teaserMini) === '/404'"
          [caasData]="teaserMini"
          [isMini]="true"
          [miniBadges]="getMiniTeaserBadge(teaserMini)"
          [isMini]="true"
          [ngClass]="
            isGreen && !isSectionGrey ? 'mini-teaser-green' : 'mini-teaser'
          "
        >
        </hdi-teaser>
      </ng-container>
    </ng-container>
    <!-- End Mini Teaser -->
    <!-- Standard Teasers -->
    <ng-container
      *ngIf="
        type === 'standard' &&
        caasData?.formData?.st_standard_layout?.value?.identifier !== 'slider'
      "
    >
      <hdi-teaser
        *ngFor="let teaser of caasData?.formData?.st_items?.value"
        [caasData]="teaser"
        [columns]="columns"
        [reverse]="imageOrientation === 'Rechts'"
        [layout]="caasData?.formData?.st_layout?.value?.identifier"
        [className]="
          caasData?.formData?.st_layout?.value?.identifier === 'horizontal'
            ? 'quer'
            : ''
        "
      ></hdi-teaser>
    </ng-container>
    <!-- End Standard Teasers -->
    <!-- News Teasers -->
    <ng-container *ngIf="newsTeasers$ | async as newsTeasersList">
      <hdi-teaser
        *ngFor="let teaser of newsTeasersList"
        [imageBorder]="teaser.imageBorder"
        [badges]="teaser.badges"
        [type]="teaser.type"
        [headline]="teaser.headline"
        [description]="teaser.description"
        [imageSrc]="teaser.imageSrc"
        [imageAlt]="teaser.imageAlt"
        [imageTitle]="teaser.imageTitle"
        [target]="teaser.target"
        [label]="teaser.label ?? '' | capitalize"
        [href]="teaser.href ? teaser.href : ''"
        [hrefType]="teaser.hrefType ? teaser.hrefType : HrefType.ANGULAR_ROUTE"
        [columns]="columns"
        [layout]="caasData?.formData?.st_layout?.value?.identifier"
      ></hdi-teaser>
    </ng-container>
    <!-- End News Teasers -->
  </div>
  <!-- End List Teaser Template -->
  <div class="teaser-container-button" *ngIf="showMoreLess">
    <hdi-button
      [type]="ButtonType.SECONDARY_ICON"
      [label]="showMoreLessLabel | capitalize"
      [iconName]="iconSelected"
      (click)="toggleTeasersVisibility()"
      (keydown)="toggleTeasersVisibility()"
    ></hdi-button>
  </div>
</div>

<!-- Loading Placeholder -->
<ng-template #loadingTeaserContainer>
  <hdi-teaser-container-loader></hdi-teaser-container-loader>
</ng-template>
